import { IShareButtonsProps } from '../ShareButtons.props';

export const shouldDisplayLabel = (
  buttonContent: IShareButtonsProps['buttonContent'],
) => buttonContent !== 'Icon';

export const shouldDisplayIcon = (
  buttonContent: IShareButtonsProps['buttonContent'],
) => buttonContent !== 'Text';
